<template>
    <div class="site-logo">
        <router-link to="/">
            <img :src="appLogo2" alt="site logo" style="margin: 10px 0 10px 0; width: 100px">
        </router-link>
    </div>
</template>

<script>
import AppConfig from "Constants/AppConfig";
import { mapGetters } from "vuex";

export default {
   computed: {
      ...mapGetters(["sidebarSelectedFilter"])
   },
   data() {
      return {
          appLogo2: AppConfig.appLogo2
      }
   }
}
</script>
